/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_EmptyInputs */

const cs_gdpr_review_empty = /** @type {(inputs: Gdpr_Review_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic k posouzení.`)
};

const en_gdpr_review_empty = /** @type {(inputs: Gdpr_Review_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to review.`)
};

/**
* | output |
* | --- |
* | "Nothing to review." |
*
* @param {Gdpr_Review_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_empty = /** @type {((inputs?: Gdpr_Review_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_empty(inputs)
	return cs_gdpr_review_empty(inputs)
});